/**
 * AI Insights page — localization manifest.
 */
export const aiInsightsManifest: readonly string[] = [
  "aiInsights.title",
  "aiInsights.subtitle",
  "aiInsights.runAnalysis",
  "aiInsights.running",
  "aiInsights.llmEnrichment",
  "aiInsights.noInsights",
  "aiInsights.noInsightsHint",
  "aiInsights.analysisComplete",
  "aiInsights.generateProposals",
  "aiInsights.generatingProposals",
  "aiInsights.loadingInsights",
  "aiInsights.riskScore",
  "aiInsights.summary",
  "aiInsights.noSummary",
  "aiInsights.insightType",
  "aiInsights.analysisWindow",
  "aiInsights.safety",
  "aiInsights.quotaRuns",
  "aiInsights.quotaInsights",
  "aiInsights.quotaLeft",
  "aiInsights.lastRun",
  "aiInsights.llmEnriched",
  // Shared
  "nav.aiInsights",
  "common.loading",
  "common.noData",
  "common.refresh",
  "severity.critical",
  "severity.high",
  "severity.medium",
  "severity.low",
] as const;
